import { Button } from 'src/modules/common/components/Button/Button.tsx';
import { Link, useLocation } from 'react-router-dom';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { SelectionListIcon } from 'src/modules/common/icons/SelectionListIcon.tsx';
import { AnyLocationState } from 'src/projects/types/AnyLocationState.ts';

export const SelectionsButton = ({
    locationState,
    searchParams,
}: {
    searchParams: URLSearchParams;
    locationState: AnyLocationState;
}) => {
    const location = useLocation();
    return (
        <Button
            as={Link}
            size="md"
            kind="tertiary"
            to={{
                pathname: `${location.pathname}/projects/1`.replace(/[/]+/g, '/'),
                search: searchParams.toString(),
            }}
            state={locationState}
        >
            <I18n messageId={MESSAGES.openProjectPageButton}/>

            <div className="vss-user-input-page__icon">
                <SelectionListIcon/>
            </div>
        </Button>
    );
};
